import { atom, selector } from 'recoil'
import { campaignState } from './campaign'

export const pageState = atom({
  key: 'CampaignPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    isFullScreen: false,
    displayCarousel: true,
    step2SelectTemplate: true,
    initBeePlugin: false, // true dopo il check,
    forceTemplates: false,
    isEnd: false
  }
})

export const wizardSteps = atom({
  key: 'campaignWizardState',
  default: {
    wizardStep: 1,
    wizardStepsDone: 0
  }
})

export const wizardEnableStep1State = selector({
  key: 'campaignWizardEnableStep1State',
  get: ({ get }) => {
    const { isOnSent } = get(messageIsOnSentState)
    return !isOnSent
  }
})

export const wizardEnableStep2State = selector({
  key: 'campaignWizardEnableStep2State',
  get: ({ get }) => {
    const { isOnSent } = get(messageIsOnSentState)
    const { wizardStepsDone } = get(wizardSteps)

    return isOnSent ? false : wizardStepsDone >= 1
  }
})

export const wizardEnableStep3State = selector({
  key: 'campaignWizardEnableStep3State',
  get: ({ get }) => {
    const { isOnSent } = get(messageIsOnSentState)
    const { wizardStepsDone } = get(wizardSteps)

    return isOnSent ? false : wizardStepsDone >= 2
  }
})

export const wizardEnableStep4State = selector({
  key: 'campaignWizardEnableStep4State',
  get: ({ get }) => {
    const { wizardStepsDone } = get(wizardSteps)

    return wizardStepsDone >= 3
  }
})

export const sourceListState = atom({
  key: 'CampaignSourceListStateState',
  default: {
    sourceList: []
  }
})

export const step1EnabledState = selector({
  key: 'campaignWizardstep1EnabledState',
  get: ({ get }) => {
    const { Name, IdSource, EmailOptions, ShowNumberOfContents } =
      get(campaignState)

    if (!Name) return false
    if (!IdSource || IdSource <= 0) return false
    if (EmailOptions.SubjectType === 3 && EmailOptions.Subject === '')
      return false
    if (ShowNumberOfContents < 1 || ShowNumberOfContents > 1000) return false
    return true
  }
})

export const segmentationFiltersState = atom({
  key: 'campaignWizard__segmentationFiltersState',
  default: {
    optionGroups: []
  }
})

export const stepState = atom({
  key: 'campaignWizard_stepState',
  default: {
    step3: {
      senderInfo: {
        senderNameIsDirty: false,
        senderEmailIsDirty: false,
        sernderEmailValid: false,
        sernderEmailTrustedVariant: 'neutral',
        replyToIsDirty: false,
        replyToIsInvalid: false,
        fetchedSender: false,
        listInfoDetailsLoaded: false,
        listInfoDetailsLoading: false
      },
      sendingFrequency: {
        numberNewContentIsDirty: false,
        checkFrequencyIsDirty: false,
        timeZoneisDirty: false
      }
    }
  }
})

export const step3IsEnabledState = selector({
  key: 'campaignWizardstep3IsEnabledState',
  get: ({ get }) => {
    const {
      EmailOptions: { SenderEmail, SenderName, ReplyTo },
      CheckNumberOfNewContents,
      CheckFrequencyType
    } = get(campaignState)
    const { d } = get(checkFrequencyState)

    const {
      step3: {
        senderInfo: { sernderEmailValid }
      }
    } = get(stepState)
    if (
      !SenderEmail ||
      !SenderName ||
      !ReplyTo ||
      !sernderEmailValid ||
      !CheckNumberOfNewContents ||
      (CheckFrequencyType === 2 && d.length === 0)
    )
      return false

    return true
  }
})

export const checkFrequencyState = atom({
  key: 'campaignWizard__checkFrequencyState',
  default: {
    h: 0,
    m: 0,
    d: []
  }
})

export const checkFrequencySelector = selector({
  key: 'campaignWizard__checkFrequencySelector',
  get: ({ get }) => {
    const { h, m, d } = get(checkFrequencyState)

    return `${m || 0} ${h || 0} * * ${d}`
  }
})

export const sendingRowData = atom({
  key: 'campaignWizard__sendingRowData',
  default: {
    sourceName: '',
    sourceType: '',
    includeGroups: [],
    excludeGroups: [],
    applyFilters: []
  }
})

export const thumbnailState = atom({
  key: 'campaignWizard__thumbnailState',
  default: {
    state: '',
    url: ''
  }
})

export const messageIsOnSentState = atom({
  key: 'campaignWizard__messageIsOnSentState',
  default: {
    isOnSent: false,
    showMessageBox: false
  }
})
